import React, { useState } from 'react';
import * as SimpleIcons from 'simple-icons/icons';
import './BrandLogo.css';

// Mapeo de marcas a sus íconos de simple-icons
const BRAND_ICON_MAP = {
  'HP': 'siHp',
  'DELL': 'siDell',
  'LENOVO': 'siLenovo',
  'ASUS': 'siAsus',
  'ACER': 'siAcer',
  'EPSON': 'siEpson',
  'XIAOMI': 'siXiaomi',
  'APPLE': 'siApple',
  'SAMSUNG': 'siSamsung',
  'HUAWEI': 'siHuawei',
  'MOTOROLA': 'siMotorola',
  'LG': 'siLg',
  'NOKIA': 'siNokia',
  'SONY': 'siSony',
  'CANON': null, // Usar imagen local
  'SIRAGON': null, // No disponible en simple-icons, usar imagen local
  'KYOCERA': null,
  'KONICA': null,
  'LEXMARK': null
};

const LOCAL_LOGOS = {
  'CANON': '/brand-logos/canon.png',
  'SIRAGON': '/brand-logos/siragon.png',
  'KYOCERA': '/brand-logos/kyocera.png',
  'KONICA': '/brand-logos/konica.png',
  'LEXMARK': '/brand-logos/lexmark.png'
};

function BrandLogo({ brand, onSave, isEditable = false }) {
  const [isEditing, setIsEditing] = useState(false);
  const [currentValue, setCurrentValue] = useState(brand);
  const normalizedBrand = brand?.toUpperCase();

  const iconKey = BRAND_ICON_MAP[normalizedBrand];
  const localLogo = LOCAL_LOGOS[normalizedBrand];
  const simpleIcon = iconKey ? SimpleIcons[iconKey] : null;

  const handleDoubleClick = () => {
    if (isEditable) {
      setIsEditing(true);
    }
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    setCurrentValue(newValue);
    onSave?.(newValue);
    setIsEditing(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      const newValue = e.target.value;
      setCurrentValue(newValue);
      onSave?.(newValue);
      setIsEditing(false);
    }
    if (e.key === 'Escape') {
      setIsEditing(false);
      setCurrentValue(brand);
    }
  };

  if (isEditing) {
    return (
      <select
        value={currentValue || ''}
        onChange={handleChange}
        onBlur={() => setIsEditing(false)}
        onKeyDown={handleKeyPress}
        autoFocus
        className="brand-select"
      >
        <option value="">Seleccionar...</option>
        {Object.keys(BRAND_ICON_MAP).map((brandName) => (
          <option key={brandName} value={brandName}>
            {brandName}
          </option>
        ))}
      </select>
    );
  }

  return (
    <div className="brand-container" onDoubleClick={handleDoubleClick} title={brand}>
      {simpleIcon ? (
        <svg
          className="brand-logo-svg"
          role="img"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d={simpleIcon.path} fill={`#${simpleIcon.hex}`} />
        </svg>
      ) : localLogo ? (
        <img
          src={localLogo}
          alt={`${brand} logo`}
          className="brand-logo"
        />
      ) : (
        <span className="brand-name-only">{brand}</span>
      )}
    </div>
  );
}

export default BrandLogo; 